export default __webpack_public_path__ + "static/media/avatar_unicorn2.7fcbd6b2.mp3";